export default "__VITE_ASSET__BSz3NQWE__"